import { Box } from '@chakra-ui/react'

export function ResultGroupHeader({ label }: { label: string }) {
    return (
        <Box py="8px" px="16px" fontSize="10px" textTransform="uppercase" opacity={0.5}>
            {label}
        </Box>
    )
}
